import { FC } from 'react';
import { Modal as AntdModal, Flex, Typography } from 'antd';
import { CustomButton } from 'src/components/ui';
import './index.scss';

interface Props {
  onCancel: () => void;
  onOk: () => void;
  title: string;
  description: string;
  okText?: string;
  cancelText?: string;
  open: boolean;
  footer?: any;
}

export const Modal: FC<Props> = ({
  open,
  onCancel,
  onOk,
  title,
  description,
  okText,
  cancelText,
  footer,
}) => {
  return (
    <AntdModal
      open={open}
      onCancel={onCancel}
      onOk={onOk}
      footer={null}
      styles={{
        mask: {
          backdropFilter: 'blur(10px)',
          backgroundColor: 'rgba(0, 0, 0, 0.3)',
          zIndex: 99999
        },
        wrapper: {
          zIndex: 999999
        }
      }}
      centered
      width={460}
      className={'my-profile-modal'}
    >
      <Flex vertical gap={16} className={'modal-content'}>
        <Typography.Text className={'title'}>{title}</Typography.Text>

        <Typography.Text className={'description'}>
          {description}
        </Typography.Text>
      </Flex>

      <Flex vertical gap={12}>
        <CustomButton type={'primary'} text={okText} onClick={onOk} />
        <CustomButton type={'default'} text={cancelText} onClick={onCancel} />
        {footer}
      </Flex>
    </AntdModal>
  );
};
